import { getApiBaseUrl } from "@/lib/api/base-url";

export const API_CONFIG = {
    BASE_URL: getApiBaseUrl(),
    TIMEOUT: 30000,
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000,
    MAX_RETRY_DELAY: 10000, // ms, cap for exponential backoff
    MAX_RETRY_TOTAL_MS: 30000, // ms, total retry window
    DEBUG: process.env.NODE_ENV !== 'development' ? false : (process.env.NEXT_PUBLIC_API_DEBUG === 'true' || false),
} as const;
